import { ReactComponent as IconTemperatureError } from "../../../assets/img/icon_temperature_error.svg"
import { ReactComponent as IconTemperatureWarning } from "../../../assets/img/icon_temperature_warning.svg"
import { WarningType } from "./WarningType"

export const TemperatureIcon: React.FC<{ type: WarningType }> = ({type}) => {
    switch(type){
        case WarningType.Warning:
            return <IconTemperatureWarning width={24} height={24} />
        default:
            return <IconTemperatureError width={24} height={24} />
    }
}